<template>
  <nav role="navigation" class="main-nav-menu">
    <div
      v-for="(group, index) in mainMenu"
      :key="index"
      class="main-nav-menu__group"
      data-test-id="main-nav-menu-group"
    >
      <EList>
        <EListItem v-for="item in group" :key="item.label">
          <a
            :href="item.url"
            data-track-id="menu"
            class="main-nav-menu__link"
            data-test-id="main-nav-menu-link"
            rel="noopener"
            @click="onClick(item.url)"
          >
            {{ $t(`${translationStringPrefix}${item.key}${translationStringSufix}`) }}
          </a>
        </EListItem>
      </EList>
    </div>
  </nav>
</template>

<script>
import { mapState } from 'vuex';
import { getMainMenu } from '~~/common/js/universal/menus';
import { sendCoreAnalyticsEvent } from '~~/common/js/client/analytics';

import EList from '~~/common/vue/components/list';
import EListItem from '~~/common/vue/components/list-item';

export default {
  name: 'EMainNavMenu',
  components: {
    EList,
    EListItem,
  },
  props: {
    translationStringPrefix: {
      type: String,
      default: 'common.header.menu.',
    },
    translationStringSufix: {
      type: String,
      default: '',
    },
    settingsUrl: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapState('global', ['locale']),
    mainMenu() {
      return getMainMenu({
        locale: this.locale,
        settingsUrl: this.settingsUrl,
        infoUrl: this.$config.infoUrl,
      });
    },
  },
  methods: {
    onClick(href) {
      sendCoreAnalyticsEvent('menuNavMenuClicked', {
        href,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.main-nav-menu {
  font-size: $font-m;
  color: var(--color-text-primary);
  min-width: 240px;

  .list-item {
    padding: 0;
  }
}

.main-nav-menu__group {
  @include divider('bottom');

  &:last-child {
    border-bottom: 0;
  }
}

.main-nav-menu__link {
  display: block;
  line-height: $space-m;
  padding: $space-m $space-1s $space-m $space-m;

  @include desktop {
    padding: $space-s $space-1s $space-s $space-m;
  }
}
</style>
